import { EventHelper as ShopEventHelper } from '@shop/frontend/web/js/helpers/EventHelper';
import { translator } from '@shop/frontend/web/js/services/TranslatorService';

class EventHelper extends ShopEventHelper {
  /**
   * Создает название для места (например для тултипа)
   * @param {string[]} values - Массив значении в виде: [Место, Ряд, Сектор]
   * @return {string} - Возвращает строку в виде: Ряд 3, место 21
   */
  createPlaceName(values) {
    if (!values[1]) return '';

    return `${translator.t('event', 'Row')} ${values[1]}, ${translator.t('event', 'place')} ${values[0]}`;
  }

  setActivePlaces(carts) {
    $.each(carts, (index, cart) => {
      const selector = $(`#${cart.sid}`);

      selector.attr('data-price', cart.price);
      selector.attr('is_pack', cart.is_pack ? 'true' : 'false');

      selector.addClass('in-cart active');
      if (!cart.is_pack) selector.attr('data-available', 'false');
    });
  }
}

export const eventHelper = new EventHelper();
